import * as React from "react";
import { paramCase } from "change-case";
import { appConfig } from "../../../config";
import { IExplorerProperties, IColumnMap, IGroupedRow } from "../../models";

import * as moment from "moment";
import { Tooltip } from "../../assets/Tooltip/Tooltip";
import { ExplorerFundRow } from "../ExplorerFundRow/ExplorerFundRow";
import { Card } from "./";
import { safe, getValueFromStringNotation, isNullOrUndefined, groupBy, getDisplayValue, isPrint, getCurrencySymbol, isShareDisabled, addItemToGoogleTracking } from "../../utils";
import { LoadingIcon } from "../../assets/LoadingIcon/LoadingIcon";
import { NoData } from "../../assets/NoData/NoData";
import { ArrowIndicator } from "../../assets";
import { CONTACT_US_URL } from "../../config";

// tslint:disable-next-line:variable-name
const FaAngleRight = require('react-icons/lib/fa/angle-right');
const styles = require('../FundPages/Fundpages.pcss');
const internalStyles = require('./ExplorerTabContent.pcss');
const tableTooltips = require('./overrides/tableTooltips.pcss');
const arrowIndecator = require('./overrides/arrowIndecator.pcss');

// tslint:disable-next-line:interface-name
interface ExplorerTabContentState {
	width?: number;
}

interface IProps {
	children?: any;
	columns?: IColumnMap[];
	groupedRows?: IGroupedRow[];
	toggleRows?: any;
	rowExpandComponent?: any;
	isPPL?: boolean;
}

export class ExplorerTabContent extends React.Component<IProps & IExplorerProperties, ExplorerTabContentState>{

	constructor(props) {
		super(props);
		this.updateLocalState = this.updateLocalState.bind(this);
	}

	goToFundPage(shareClass, event) {
		let { appParams } = this.props;
		let envs = Object.keys(appConfig.envDetails);
		let envUrls = [];
		envs.map(e => {
			envUrls.push(appConfig.envDetails[e]['baseurl'].toLowerCase());
		});

		if (!isShareDisabled(shareClass.clientCode)) {
			let fundPageUrl;
			if (envUrls.indexOf(appParams.baseurl.toLowerCase()) > -1) {
				//maintain tools appParams (test pdf downloads on tools)
				fundPageUrl = `${appParams.baseurl}funds/${paramCase(shareClass.properties["fund_name"])}/${(shareClass.properties["isin"] as string).toLowerCase()}/${appParams.region}/${appParams.clienttype}/${appParams.language}`;
			} else {
				fundPageUrl = `${appParams.baseurl}funds/${paramCase(shareClass.properties["fund_name"])}/${(shareClass.properties["isin"] as string).toLowerCase()}/`;
			}
			window.location.href = fundPageUrl;
		}
	}

	updateLocalState() {
		this.setState({ width: window.innerWidth });
	}

	componentWillMount() {
		this.updateLocalState();
	}

	componentDidMount() {
		window.addEventListener('resize', this.updateLocalState);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateLocalState);
	}

	render() {
		let { isLoading, appParams } = this.props;
		let { width } = this.state;

		if (isLoading) {
			return <LoadingIcon isLoading={isLoading} />;
		}

		if (width > 1000 || isPrint(appParams)) {
			return this.renderTable();
		}
		else {
			return this.renderCards();
		}

	}

	renderCards() {
		let { columns, groupedRows, toggleShareClass, editWatchlist, watchlist, appParams, isPPL, benchmarks } = this.props;

		// Prevents second render and dropping of appParams from props
		if (!appParams) {
			return null;
		}

		let rows = [];
		let displayMode = isPrint(appParams) ? 'print' : 'web';
		let displayColumns = columns.filter(column => !column.explicitHide && (!column.displayLimitation || displayMode === column.displayLimitation));
		let fundColSpan = displayColumns.reduce((existing, current) => {
			existing += current.colSpan || 1;
			return existing;
		}, 0) + (isPrint(appParams) ? 0 : 1);

		for (let groupedRow of groupedRows) {
			let rowIndex = 0;
			let { fund } = groupedRow;
			for (let row of groupedRow.rows) {
				rows.push(
					<Card
						isPPL={isPPL}
						key={row.key}
						columns={columns}
						row={row}
						groupedRow={groupedRow}
						rowIndex={rowIndex}
						watchlist={watchlist}
						appParams={appParams}
						editWatchlist={editWatchlist}
						goToFundPage={this.goToFundPage.bind(this)}
						benchmarks={benchmarks}
						toggleShareClass={toggleShareClass}>
					</Card>
				);
				rowIndex++;
			}
		}
		return (
			<div>
				<div>{rows}</div>
				{(() => {
					if (rows.length === 0) {
						return <NoData />;
					}
				})()}
			</div>
		);
	}

	//THIS IS RENDERING 3 TIMES?
	renderTable() {
		let { columns, funds, groupedRows, toggleFund, isPPL, appParams } = this.props;

		// Prevents second render and dropping of appParams from props
		if (!appParams) {
			return null;
		}
		const sharePriceFundList = safe(() => this.props.sharePriceFundList.SharePriceFundListResponse[0].funds, []);
		let displayMode = isPrint(appParams) ? 'print' : 'web';
		let displayColumns = columns.filter(column => !column.explicitHide && (!column.displayLimitation || displayMode === column.displayLimitation));
		let rows = [];
		let fundColSpan = displayColumns.reduce((existing, current) => {
			existing += current.colSpan || 1;
			return existing;
		}, 0) + (isPrint(appParams) ? 0 : 1);

		for (let groupedRow of groupedRows) {
			let { fund } = groupedRow;
			let activeRow = !groupedRow.collapsed ? styles.active : '';
			let internalClasses = {
				active: `${styles.dropdownbutton} ${activeRow}`,
			};
			if (groupedRow.rows.length > 0) {
				rows.push(<ExplorerFundRow key={fund['clientCode']} appParams={appParams} fund={fund} colSpan={fundColSpan} toggleRows={toggleFund}></ExplorerFundRow>);
			}

			if (!fund.collapsed) {
				let rowIndex = 0;
				for (let row of groupedRow.rows) {
					let activeRow = styles.active;
					let internalClasses = {
						rowActive: styles.RowItems,
					};

					let [charges] = row["timeseries"].filter(item => item.code === "charges");
					let estimate_actual_not_available = "";
					if (!isNullOrUndefined(charges)) {
						estimate_actual_not_available = safe(() => charges.values[0].estimate_actual_not_available, "");
					}
					rows.push(
						<tr key={row.key}
							className={`${internalClasses.rowActive} ${!isPPL ? styles.OEIC : styles.PPL} ${isShareDisabled(row.clientCode) ? styles.rowDisabled : ""}`}
							onClick={e => !isPPL ? this.goToFundPage(row, e) : ""}>
							{(() => {
								if (!isPrint(appParams)) {
									// console.log(appParams);
									//return (<td className={styles.viewDetails}><span>View details<FaAngleRight /></span></td>);
									return (<td className={internalStyles.web}><span></span></td>);
								}
							})()}
							{displayColumns.map((column, colIndex) => {
								let { className } = column;
								let colSpan = column.colSpan || 1;
								let value;

								if (column.headerKey === 'Price') {
									if ((sharePriceFundList.indexOf(groupedRow.key) > -1) || (sharePriceFundList.indexOf(row.key)) > -1) {
										column.field = 'latestTimeseriesValues.share_prices.shareclass_price';
									}
									else {
										column.field = "latestTimeseriesValues.prices.shareclass_price";
									}
								}
								if (column.type === 'component') {
									value = React.cloneElement(column.component, column.getPropsFn(row, groupedRow));
								}
								else if (column.type === 'custom') {
									value = column.customJsx;
								}
								else if (column.entity === "fund") {
									value = getValueFromStringNotation(column.field, groupedRow);
									value = getDisplayValue(value, column);
								}
								else if (column.isYearToDate) {
									const dateToday = moment();
									const dateIncetion = moment(row.properties.launch_date);
									console.log(appParams.clienttype);
									const url = CONTACT_US_URL[appParams.clienttype];
									if (dateToday.diff(dateIncetion, "years") < 1 && url) {
										value = <a className="ytdCell" href={url} onClick={(event) => event.stopPropagation()} target="_blank">Contact us ></a>;
									}
									else {
										value = getValueFromStringNotation(column.field, row);
										value = getDisplayValue(value, column);
									}
								}
								else {
									if (isNullOrUndefined(column.isPropertyAssetClass)) {
										value = getValueFromStringNotation(column.field, row);
										value = getDisplayValue(value, column);
									}
									else {
										let isProperty = groupedRow.fund.properties["asset_class"] === "Property" || row["properties"]["fund_key"] === "HIT";
										if (column.isPropertyAssetClass) {
											if (isProperty && !isPPL) {
												value = "n/a";
											}
											else {
												if (column.fields) {
													let values = column.fields.map(item => getDisplayValue(getValueFromStringNotation(item, row), column));
													value = values.join(column.fieldSeperator);
												} else {
													value = getValueFromStringNotation(column.field, row);
													value = getDisplayValue(value, column);
												}
											}
										}
										else {
											if (!isProperty && !isPPL) {
												value = "n/a";
											}
											else {
												if (column.fields) {
													let values = column.fields.map(item => getDisplayValue(getValueFromStringNotation(item, row), column));
													value = values.join(column.fieldSeperator);
												} else {
													value = getValueFromStringNotation(column.field, row);
													value = getDisplayValue(value, column);
												}
											}
										}
									}
									let pattern = new RegExp(/{shareTypeAbbreviation}/g);
									value = value.toString().replace(pattern, "");
								}

								let currencySymbol = safe(() => getCurrencySymbol(row["properties"]["currency"] as string), { isMajor: false, value: "" });

								if ((column.headerKey === "Price" || column.headerKey === "Bid / Offer Prices") && value !== "n/a") {
									if (sharePriceFundList.indexOf(row.key) > -1) {
										column.field = 'latestTimeseriesValues.share_prices.shareclass_price';
									}
									else {
										column.field = "latestTimeseriesValues.prices.shareclass_price";
									}

									if (value.indexOf(" / ") === -1) {
										value = `${currencySymbol.isMajor ? `${currencySymbol.value}` : ""}${value}${currencySymbol.isMajor ? "" : `${currencySymbol.value}`}`;
									} else {
										let valueArr = value.split(" / ");
										value = valueArr.map(item => `${currencySymbol.isMajor ? `${currencySymbol.value}` : ""}${item}${currencySymbol.isMajor ? "" : `${currencySymbol.value}`}`).join(" / ");
									}
								}

								let tdValue;
								if (column.headerKey === "Change") {
									tdValue = <ArrowIndicator showValueWithArrow={true} value={value} styles={arrowIndecator}></ArrowIndicator>;
								}
								else if (column.checkEstimateActualNotAvailable && estimate_actual_not_available === "Estimate" && value !== "-") {
									tdValue = <span><em>{value} *</em></span>;
								}
								else {
									tdValue = value;
								}

								return (
									<td colSpan={colSpan} className={className} key={`row_${rowIndex}_col_${colIndex}`}>{tdValue}</td>
								);
							})}
						</tr>
					);
					rowIndex++;
				}
			}
		}
		if (columns && groupedRows) {
			let headerRows = [];
			let tooltipRow = [];
			let parentHeaderRow = [];
			let columnsGroupedByHeaderRowSpan = groupBy(columns, (item) => (item.headerRowSpan || 1).toString());
			let isFirstHeaderRow = true;
			let parentColspan = 0;
			for (let key of Object.keys(columnsGroupedByHeaderRowSpan).map((key) => parseInt(key, 10)).sort().reverse()) {
				let headerColumns = columnsGroupedByHeaderRowSpan[key.toString()];
				if (isFirstHeaderRow) {
					headerColumns = columns.filter(column => column.isParentHeader || (column.headerRowSpan || 1) === key);
				}
				tooltipRow.push(
					<tr key={key + Math.random()}>
						{isFirstHeaderRow && !isPrint(appParams) && <th className={internalStyles.firstColumn} rowSpan={1} key={'toggle'}></th>}
						{headerColumns.filter(column => (!column.explicitHide && (!column.displayLimitation || displayMode === column.displayLimitation))).map((column, index) => {
							parentColspan++;
							return (
								<th key={`col_${index}`}>
									{
										column.tooltip &&
										!column.tooltip["is_deleted"] &&
										!isPrint(appParams) &&
										<Tooltip text={column.tooltip["disclaimer"]} />}
								</th>
							);
						})}
					</tr>
				);
				let hasParentHeader = headerColumns.filter(column => (isFirstHeaderRow && column.isParentHeader));
				if (hasParentHeader.length > 0) {
					parentHeaderRow.push(
						<tr key={key + Math.random()}>
							{isFirstHeaderRow && !isPrint(appParams) && <th className={internalStyles.firstColumn} rowSpan={1} key={'toggle'}></th>}
							{headerColumns.filter(column => (isFirstHeaderRow && column.isParentHeader)).map((column, index) => {
								let headerValue = column.headerKey || '';
								let parentHeaderStyle = {};
								if (column.paddingLeft) {
									parentHeaderStyle = {
										...parentHeaderStyle, ...{
											paddingLeft: `${column.paddingLeft}%`
										}
									};
								}
								return (
									<th key={`col_${index}`} style={parentHeaderStyle} colSpan={parentColspan}>
										<span className={styles.headerValue}>{headerValue}</span>
									</th>
								);
							})}
						</tr>
					);
				}
				headerRows.push(
					<tr key={key + Math.random()}>
						{isFirstHeaderRow && !isPrint(appParams) && <th className={internalStyles.firstColumn} rowSpan={key} key={'toggle'}></th>}
						{headerColumns.filter(column => (!column.explicitHide && (!column.displayLimitation || displayMode === column.displayLimitation))).map((column, index) => {
							let headerValue = column.headerKey || '';
							return (
								<th key={`col_${index}`} colSpan={column.headerColSpan} className={column.headerClassName}>
									<span className={styles.headerValue}>{headerValue}</span>
								</th>
							);
						})}
					</tr>
				);
			}
			isFirstHeaderRow = false;
			if (!funds.isDefaultState) {
				setTimeout(() => {
					window.status = "pdfdataloaded";
					global['docdone'] = true; //electron using exportPdf endpoint of FundPress
				}, 1000);
			}
			let printStyle = isPrint(appParams) ? styles.print : "";
			return (
				<div>
					<table className={styles.table + " " + printStyle} cellSpacing="0">
						<thead>
							{tooltipRow}
							{parentHeaderRow}
							{headerRows}
						</thead>
						<tbody>
							{rows}
						</tbody>
					</table>
					{rows.length === 0 && <NoData />}
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/client/components/ExplorerTabContent/ExplorerTabContent.tsx